"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownError = void 0;
var UnknownError = /** @class */ (function () {
    function UnknownError() {
    }
    UnknownError.messageByAxiosError = function (reason) {
        var _a, _b;
        return 'Unknown Error: ' + JSON.stringify((_b = (_a = reason.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : 'There is no axios response.');
    };
    return UnknownError;
}());
exports.UnknownError = UnknownError;
//# sourceMappingURL=UnknownError.js.map